/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Lap_ClearInputs */

const en_ui_lap_clear = /** @type {(inputs: Ui_Lap_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear lap`)
};

const de_ui_lap_clear = /** @type {(inputs: Ui_Lap_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde abwählen`)
};

/**
* | output |
* | --- |
* | "Clear lap" |
*
* @param {Ui_Lap_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_lap_clear = /** @type {((inputs?: Ui_Lap_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Lap_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_lap_clear(inputs)
	return de_ui_lap_clear(inputs)
});